module.exports = __webpack_public_path__ + "static/media/Teams_Video.36384f68.mp4";